namespace TR {
    class CruiseListing {
        cruise: any;

        constructor(private analytics: any) { }

        gotToCruise(url) {
            this._trackClick();
            window.open(url);
        }

        private _trackClick() {
            this.analytics.track(
                'mixpanel',
                'HolidayDealsCruiseDetails',
                {
                    Title: this.cruise.Title,
                    ShipName: this.cruise.ShipName,
                    LineName: this.cruise.CruiseLineName
                }
            );
        }
    }

    angular
        .module('TR')
        .directive('cruiseListing', (): ng.IDirective => {
            return {
                scope: {},
                templateUrl: 'partials/home/directivetemplate?type=CruiseListing',
                replace: true,
                bindToController: {
                    cruise: '=',
                    priceMode: '=',
                },
                controller: CruiseListing,
                controllerAs: 'cl'
            };
        });

}
